import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Pack Test',
  price: '99',
  description: 'Ideal para probar nuevos ángulos.',
  features: ['5 Ads', 'Ejecución Directa: Tú nos entregas el ángulo y formato; nosotros nos encargamos de la producción técnica.', 'Entrega en 48hs', 'Llamada Estratégica'],
  highlight: false,
  color: 'text-white',
  buttonBg: 'bg-white/10 hover:bg-white/20 text-white',
  link: 'https://wa.link/kcmkkm'
}, {
  name: 'Pack Validación',
  price: '199',
  description: 'El punto dulce para escalar campañas.',
  features: ['15 Ads Ganadores', 'Investigación de Mercado: Analizamos tu mercado, detectamos dolores, deseos y ángulos de venta con mayor potencial.', 'Ingeniería de Formatos: Nosotros definimos la mezcla de formatos (UGC, Demo, etc.) según lo que mejor convierta para tu producto.', 'Variaciones de Hook: Testeamos diferentes ganchos para maximizar el CTR.', 'Soporte Prioritario vía Chat.', 'Llamada Estratégica'],
  highlight: true,
  color: 'text-[#95BF47]',
  buttonBg: 'bg-[#95BF47] hover:bg-[#84a93f] text-black glow-green',
  link: 'https://wa.link/ei6xtp'
}, {
  name: 'Pack Escala',
  price: '499',
  description: 'Dominio total de tu nicho.',
  features: ['45 Ads Ganadores', 'Estrategia de Dominio: Investigación profunda de mercado, psicología del consumidor, detección de dolores, deseos y ángulos de venta masivos.', 'Testeo Masivo de Ángulos: Cubrimos todos los frentes posibles para asegurar el escalado.', 'Ingeniería de Formatos Pro: Mezcla optimizada de UGC, Demos, Comparativos y VSLs cortos.', 'Iteración Continua: Optimizamos los ganchos según el rendimiento.', 'Llamada Estratégica'],
  highlight: false,
  color: 'text-[#FFD700]',
  buttonBg: 'bg-white/10 hover:bg-white/20 text-white',
  link: 'https://wa.link/b1mbyo'
}];
export function Pricing() {
  const [activePlan, setActivePlan] = useState(1);
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#050505]" data-id="element-45">
      <div className="max-w-7xl mx-auto" data-id="element-46">
        <div className="text-center mb-16" data-id="element-47">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-48">
            Planes de Producción
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-49">
            Escala tus creativos sin escalar tus costos internos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-50">
          {plans.map((plan, index) => {
          const isActive = index === activePlan;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`relative p-8 rounded-3xl bg-[#111] transition-all duration-300 cursor-pointer ${isActive ? 'border-2 border-[#A3C664] shadow-[0_0_30px_rgba(163,198,100,0.3)] opacity-100 md:-translate-y-4' : 'border border-white/10 opacity-60 hover:opacity-80'}`} onClick={() => setActivePlan(index)} data-id="element-51">
                {plan.highlight && <div className={`absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 text-black text-sm font-bold rounded-full uppercase tracking-wider whitespace-nowrap transition-colors duration-300 ${isActive ? 'bg-[#A3C664]' : 'bg-gray-500'}`} data-id="element-52">
                    MÁS VENDIDO
                  </div>}

                <div className="mb-8" data-id="element-53">
                  <h3 className={`text-2xl font-bold mb-2 transition-colors duration-300 ${isActive ? 'text-[#A3C664]' : 'text-white'}`} data-id="element-54">
                    {plan.name}
                  </h3>
                  <p className="text-gray-400 text-sm h-10" data-id="element-55">
                    {plan.description}
                  </p>
                  <div className="mt-4 flex items-baseline text-5xl font-black text-white" data-id="element-56">
                    <span className="text-2xl text-gray-500 mr-1" data-id="element-57">$</span>
                    {plan.price}
                    <span className="text-xl text-gray-500 ml-2 font-medium" data-id="element-58">
                      USD
                    </span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8" data-id="element-59">
                  {plan.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start text-gray-300 text-sm md:text-base" data-id="element-60">
                      <Check className={`w-5 h-5 mr-3 shrink-0 mt-0.5 transition-colors duration-300 ${isActive ? 'text-[#A3C664]' : 'text-gray-600'}`} data-id="element-61" />
                      <span className="leading-relaxed" data-id="element-62">{feature}</span>
                    </li>)}
                </ul>

                <a href={plan.link} target="_blank" rel="noopener noreferrer" onClick={e => {
              // Permite que el enlace se abra, pero también asegura que se seleccione el plan
              setActivePlan(index);
            }} className={`block w-full py-4 rounded-xl text-center font-bold transition-all duration-300 ${isActive ? 'bg-[#A3C664] hover:bg-[#8eb055] text-black shadow-[0_0_20px_rgba(163,198,100,0.4)]' : 'bg-white/10 hover:bg-white/20 text-white'}`} data-id="element-63">
                  Elegir Plan
                </a>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}